import api from './api';

const taxTemplateService = {
  getTemplates: (companyId) => api.get(`/api/companies/${companyId}/tax-templates`).then(res => res.data),
  createTemplate: (companyId, data) => api.post(`/api/companies/${companyId}/tax-templates`, data).then(res => res.data),
  updateTemplate: (companyId, templateId, data) => api.put(`/api/companies/${companyId}/tax-templates/${templateId}`, data).then(res => res.data),
  deleteTemplate: (companyId, templateId) => api.delete(`/api/companies/${companyId}/tax-templates/${templateId}`).then(res => res.data),
};

export default taxTemplateService;
